/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import { Component, Vue } from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

const namespace: string = 'userSessionModule';

/**
 * Site footer component.
 *
 */

@Component({
    name: 'c-site-footer',
})

export default class SiteFooter extends Vue {
    // Page Title
    @Action('updatePageTitle', {namespace: 'settingsModule'})
    public updatePageTitle!: (title: string) => void;

    // User Session
    @Action('updateCurrentView', {namespace})
    public updateCurrentView!: (view: {name: string, params?: any} | undefined) => void;
    @Getter('authenticated', {namespace}) public authenticated!: any;

    /**
     * Goto Page.
     */
    public goToPage(pageName: string): void {
        // todo find a better way to update pageTitle in masthead and currentView for login and logout
        // have same code in siteNavigation
        if ('report-issue' === pageName) {
            this.updateCurrentView({name: pageName});
            this.updatePageTitle(this.$i18n.translate('menu.header.reportIssue', {}) || '');
        }
        this.$router.push({name: pageName});
    }
}
